import { useTranslation } from 'react-i18next';

export const CARD_TRANSLATION_KEYS: Record<string, string> = {
  TOP: 'Advertise.btn_upgrade_top',
  PREMIUM: 'Advertise.btn_upgrade_premium',
  BALANCE: 'InsufficientBalanceModal.modal_title'
} as const;

export const useContentTitle = () => {
  const { t } = useTranslation();

  return (card: string, isAddBalance?: boolean): string => {
    const computedKey = isAddBalance
      ? CARD_TRANSLATION_KEYS.BALANCE
      : CARD_TRANSLATION_KEYS[card];

    return t(computedKey);
  };
};
